/* global axios */
import ApiClient from './ApiClient';

class MetricsAPI extends ApiClient {
  constructor() {
    super('metrics', { accountScoped: true });
  }

  getOverview({ from, to, pipelineIds, channels, assigneeIds }) {
    return axios.get(`${this.url}/overview`, {
      params: {
        from,
        to,
        pipeline_ids: pipelineIds,
        channels,
        assignee_ids: assigneeIds,
      },
    });
  }

  getFunnel({ from, to, pipelineIds, channels, assigneeIds }) {
    return axios.get(`${this.url}/funnel`, {
      params: {
        from,
        to,
        pipeline_ids: pipelineIds,
        channels,
        assignee_ids: assigneeIds,
      },
    });
  }

  getRankings({ from, to, pipelineIds, channels, assigneeIds }) {
    return axios.get(`${this.url}/rankings`, {
      params: {
        from,
        to,
        pipeline_ids: pipelineIds,
        channels,
        assignee_ids: assigneeIds,
      },
    });
  }

  getDistribution({ from, to, pipelineIds, channels, assigneeIds }) {
    return axios.get(`${this.url}/distribution`, {
      params: {
        from,
        to,
        pipeline_ids: pipelineIds,
        channels,
        assignee_ids: assigneeIds,
      },
    });
  }

  triggerSync() {
    return axios.post(`${this.url}/sync`);
  }

  getConnections() {
    return axios.get(`${this.baseUrl()}/metrics_ads_connections`);
  }

  createConnection(connection) {
    return axios.post(`${this.baseUrl()}/metrics_ads_connections`, {
      metrics_ads_connection: connection,
    });
  }

  updateConnection(id, connection) {
    return axios.patch(`${this.baseUrl()}/metrics_ads_connections/${id}`, {
      metrics_ads_connection: connection,
    });
  }

  deleteConnection(id) {
    return axios.delete(`${this.baseUrl()}/metrics_ads_connections/${id}`);
  }

  syncConnection(id) {
    return axios.post(`${this.baseUrl()}/metrics_ads_connections/${id}/sync`);
  }
}

export default new MetricsAPI();
